import { compose, path } from "ramda";

export const scopeSelector = state => state.modules.user.profile;

export const editProfile = compose(path(["api", "editProfile"]), scopeSelector);
export const updateAvatar = compose(
  path(["api", "updateAvatar"]),
  scopeSelector
);

export const updateResume = compose(
  path(["api", "updateResume"]),
  scopeSelector
);

export const getCurrentResumeApi = compose(
  path(["api", "getCurrentResume"]),
  scopeSelector
);



// WEBPACK FOOTER //
// ./src/modules/user/profile/selectors.js